var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 38.4,
    height: 38.4,
    rx: 19.2,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4666 17.4645C14.3992 14.6386 17.0549 12.609 20.2004 12.609C21.8913 12.609 23.4186 13.209 24.6186 14.1909L28.1095 10.7C25.9823 8.84541 23.255 7.69995 20.2004 7.69995C15.4705 7.69995 11.3982 10.3982 9.44043 14.35L13.4666 17.4645Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2408 25.7125C23.151 26.4162 21.7661 26.7908 20.2 26.7908C17.0665 26.7908 14.4192 24.7768 13.477 21.9678L9.4375 25.0349C11.3928 28.9935 15.465 31.6999 20.2 31.6999C23.1329 31.6999 25.9354 30.6573 28.0342 28.6995L24.2408 25.7125Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0344 28.6995C30.2294 26.652 31.6547 23.6035 31.6547 19.6999C31.6547 18.9908 31.5456 18.2272 31.382 17.5181H20.2002V22.1544H26.6366C26.319 23.7135 25.4665 24.9211 24.2409 25.7125L28.0344 28.6995Z",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4772 21.9679C13.2385 21.2564 13.1093 20.4938 13.1093 19.7001C13.1093 18.9184 13.2346 18.1669 13.4664 17.4646L9.44019 14.3501C8.63678 15.9605 8.2002 17.7755 8.2002 19.7001C8.2002 21.6196 8.64498 23.4302 9.43766 25.0351L13.4772 21.9679Z",
    fill: "#FBBC05"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 38.4,
    height: 38.4,
    rx: 19.2,
    stroke: "#C8C8C8",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.2002 7.69995)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.991e4dad9ac13ff622bd1dc11f4ac231.svg";
export { ForwardRef as ReactComponent };